
export const BotArmsSprite = (
  <>
    <circle
      cx="10.65"
      cy="10.65"
      r="9.15"
      fill="none"
      stroke="#2e3192"
      strokeLinecap="round"
      strokeWidth="3"
    />
    <circle
      cx="58.45"
      cy="10.65"
      r="9.15"
      fill="none"
      stroke="#2e3192"
      strokeLinecap="round"
      strokeWidth="3"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="11"
      d="M10.44 10.58s6.65 10.68 6.56 29"
    />
    <path
      fill="none"
      stroke="#ccc"
      strokeLinecap="round"
      strokeWidth="10"
      d="M11.21 51.28a7.48 7.48 0 1114.48-3.77"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="11"
      d="M58.58 10.58s-6.65 10.68-6.57 29"
    />
    <path
      fill="none"
      stroke="#ccc"
      strokeLinecap="round"
      strokeWidth="10"
      d="M43 47.41a7.48 7.48 0 0114.44 3.94"
    />
  </>
);

export const BotArmsWateringSprite = (
  <>
    <circle
      cx="10.53"
      cy="10.57"
      r="9.15"
      fill="none"
      stroke="#2e3192"
      strokeLinecap="round"
      strokeWidth="3"
    />
    <circle
      cx="58.34"
      cy="10.57"
      r="9.15"
      fill="none"
      stroke="#2e3192"
      strokeLinecap="round"
      strokeWidth="3"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="11"
      d="M10.33 10.5s-28.83 7-14.83 29"
    />
    <path
      fill="#ff0"
      stroke="#006837"
      strokeWidth="2"
      d="M-14.36 55.27a3.63 3.63 0 01-1.17-.45c-2.21-2-4.39-4.11-6.58-6.17-.51-.47-1-.43-1.27.13a2.44 2.44 0 00-.15.76c-.31 3.63-.61 7.26-.92 10.89-.19 2.26-.4 4.52-.55 6.78a1.39 1.39 0 00.4 1c.17.13.69 0 1-.18 2.37-1.5 4.69-3 7.06-4.53a3.59 3.59 0 011.31-.25L5 61z"
    />
    <path
      fill="#bff41c"
      stroke="#006837"
      strokeWidth="2"
      d="M62.56 44.81C60.28 42.5 58 40.18 55.7 37.9a1.07 1.07 0 01-.29-1.3 29.4 29.4 0 001.7-11.35A30.51 30.51 0 0023.86-3.88C.72-1.89-11.81 24.69 1.39 43.79c1 1.43 2.09 2.78 3.12 4.19 1.68 2.29 3.34 4.6 5.12 7.06l-4.53.05-19.46.18-.92 8 12.62 2.65q11.52 2.44 23.05 4.92a2.29 2.29 0 011.18.77c1.2 1.57 2.33 3.19 3.49 4.8a5.35 5.35 0 008.09 1l6-5.06q11.52-9.73 23-19.46a5.32 5.32 0 00.41-8.08zM48.79 29.94a6.17 6.17 0 01-.18.77c-1.57-1.58-3.06-3.08-4.53-4.58l-6.9-7a5.34 5.34 0 00-7.44-.26l-21 17.72c-.21.18-.38.42-.64.7a24 24 0 01-2.86-7c-3.14-13.75 6.81-24.61 18.58-26A22.38 22.38 0 0149 25.28a40.45 40.45 0 01-.21 4.66z"
    />
    <path
      fill="none"
      stroke="#ccc"
      strokeLinecap="round"
      strokeWidth="10"
      d="M4.47 45.35a7.49 7.49 0 01-2.8-14.71"
    />
    <path
      fill="none"
      stroke="#006837"
      d="M10.47 55.04L23.47 73.04"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="11"
      d="M58.47 10.5s6 16.54-6.57 29"
    />
    <path
      fill="none"
      stroke="#ccc"
      strokeLinecap="round"
      strokeWidth="10"
      d="M40.42 40.29a7.48 7.48 0 119.51 11.56"
    />
  </>

);

